import Routes from "./Routes";

function App() {
  return (
    <>
      <div className="noise-overlay" />
      <Routes />
    </>
  );
}

export default App;
